import { isNotNullable } from '@bayer-int/portletce-shared';

import type { SettingValueMap, SettingDefinitionMap } from '../index';
import type { Specification } from '../../specification';
import type { FilterData, FilterDataArray } from '../../filters';
import { FilterableScaleSetting } from './scale';
import { FilterableViewSetting } from './smartView';
import { FilterableConditionSetting } from './condition';

const filterableSettings = [
    FilterableScaleSetting,
    FilterableViewSetting,
    FilterableConditionSetting,
];

/**
 * So called Filterable Settings are ordinary portlet settings that are reflected
 * in filters, that is their change can be performed externally by another portlet.
 *
 * They allow to implement setting broadcasting behavior between portlets.
 * E.g. scale or smart view selection.
 *
 * E.g. scale setting may be selected locally (if portlet supports it) or by reacting
 * on external filter event with value of type `SCALE`.
 */
export function toFilterableSettings(
    specification: Specification,
    latestFilter: FilterData,
    currentFilters: FilterDataArray,
    currentSettings: Partial<SettingValueMap>,
    currentDefinitions: Partial<SettingDefinitionMap>,
): Partial<SettingValueMap> {
    const keyedSetting = filterableSettings
        .map(({ filtersToSetting }) =>
            filtersToSetting(latestFilter, {
                specification,
                currentFilters,
                currentSettings,
                currentDefinitions,
            }),
        )
        .filter(isNotNullable);

    return Object.assign({}, ...keyedSetting);
}
